export default __webpack_public_path__ + "static/media/gral_roca.86b11044.jpg";